import type { UserDto } from "@reactive-resume/dto";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@reactive-resume/ui";
import { useLocation } from "react-router";

import { CountryPreferenceStep } from "@/client/pages/client/builder/dialogs/forfait/country-preference-step";
import { useDetectedCountry } from "@/client/services/currency/currency";

type Props = {
  user: UserDto;
};

// Choix du pays obligatoire juste après la connexion, avant tout affichage de prix.
export const CountryPreferenceGate = ({ user }: Props) => {
  const { pathname } = useLocation();

  const needsCountry = !user.countryPreferenceSetAt && !pathname.startsWith("/client/auth");

  const suggestedCountryCode = useDetectedCountry(needsCountry);

  if (!needsCountry) return null;

  return (
    <Dialog open>
      <DialogContent
        className={[
          "w-[calc(100vw-1rem)] max-w-[600px]",
          "max-h-[calc(100dvh-1rem)] overflow-y-auto",
          "rounded-[26px] border-0 bg-transparent p-2 shadow-none",
          "sm:w-[calc(100vw-2rem)]",
          "[&>button:last-child]:hidden",
        ].join(" ")}
        onEscapeKeyDown={(event) => {
          event.preventDefault();
        }}
        onInteractOutside={(event) => {
          event.preventDefault();
        }}
      >
        <DialogTitle className="sr-only">Pays de résidence</DialogTitle>
        <DialogDescription className="sr-only">
          Choisissez votre pays pour afficher les prix dans votre devise.
        </DialogDescription>

        <CountryPreferenceStep suggestedCountryCode={suggestedCountryCode} />
      </DialogContent>
    </Dialog>
  );
};
